import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { vn_app_zone_notification } from '../../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { header } from '../header';
import { adminTransmissions_template } from '../../components/templates/recruiting/adminTransmissions_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
export class admin_transmissions extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_transmissions';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Transmissions');
        this.tpl = new adminTransmissions_template('adminTransmissionsTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        this.loadReferences();
    }
    /**
     * Load references data from the API.
     *
     * @return void
     */
    loadReferences() {
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/types', [], this);
        this.XHRHdl.onReadyStateFunction = this.onTypesReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for types.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onTypesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.tpl.setTypes(JSON.parse(req.request.response || '[]'));
                obj.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/channels', [], obj);
                obj.XHRHdl.onReadyStateFunction = obj.onChannelsReturn;
                obj.XHRHdl.execute();
            });
        };
    }
    /**
     * Handle the API response for channels.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onChannelsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.tpl.setChannels(JSON.parse(req.request.response || '[]'));
                obj.getListData();
            });
        };
    }
    /**
     * Return list data.
     *
     * @return void
     */
    getListData() {
        startListLoading(this, this.tpl.builtTemplate);
        this.sendFilterCall('/api/admin/rest/api/lead/transmission', this.tpl.getViewModelForRequest(), this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getTransmissions');
    }
    /**
     * Handle the API response for data request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const rows = (responseParsed.data && responseParsed.data.paginatedData) || responseParsed.data || [];
                const vmReq = obj.tpl.getViewModelForRequest();
                const totalCount = Number(responseParsed.totalCount || 0);
                const perPage = vmReq.pagination && vmReq.pagination.itemPerPage ? Number(vmReq.pagination.itemPerPage) : 20;
                const totalPages = Math.max(1, Number(responseParsed.totalPage || Math.ceil(totalCount / Math.max(1, perPage))));
                obj.validationTemplate.clearMessages();
                obj.tpl.setTransmissions(rows);
                obj.tpl.updatePagination(totalCount);
                obj.tpl.setResultInfo(totalCount, totalPages, Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                stopListLoading(obj, obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Handle pagination click events.
     *
     * @return void
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Handle filter on change changes.
     *
     * @return void
     */
    filterOnChange() {
        this.tpl.resetPageNumber();
        this.getListData();
    }
    /**
     * Navigate to create transmission.
     *
     * @return void
     */
    createTransmission() {
        page('/admin/transmission/new');
    }
    /**
     * Navigate to edit transmission.
     *
     * @param id number
     * @return void
     */
    editTransmission(id) {
        page('/admin/transmission/' + id);
    }
    /**
     * Handle open groups.
     *
     * @return void
     */
    openGroups() {
        page('/admin/transmissionGroups');
    }
    /**
     * Handle run transmission.
     *
     * @param id number
     * @return void
     */
    runTransmission(id) {
        const req = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/run/' + id, [], this);
        req.mode = XMLHttpRequestHandler_requestType.POST;
        req.onReadyStateFunction = this.onRunReturn;
        req.execute();
    }
    /**
     * Handle the API response for run.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onRunReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const result = JSON.parse(req.request.response || '{}');
                obj.validationTemplate.clearMessages();
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, obj.formatQueuedTaskMessage(result, 'Transmission task queued.'));
            });
        };
    }
    /**
     * Build a success message that includes queued task details.
     *
     * @param result any
     * @param fallback string
     * @return string
     */
    formatQueuedTaskMessage(result, fallback) {
        const details = [];
        if (result.taskId) {
            details.push('Task #' + result.taskId);
        }
        if (result.operation) {
            details.push('operation ' + result.operation);
        }
        return details.length ? fallback + ' ' + details.join(', ') + '.' : (result.message || fallback);
    }
}
